import { ITranslations } from 'types/common';
import { ScriptsTableTransFields } from './types';
import en from 'translations/en/scriptsTable.json';
import pl from 'translations/pl/scriptsTable.json';
import sl from 'translations/sl/scriptsTable.json';

export const scriptsTableTranslations: ITranslations<ScriptsTableTransFields> = {
  name: 'scriptsTable',
  en,
  pl,
  sl,
};
